import React from "react";
import PageBanner from './PageBanner';
import LeftSection from './LeftSection';
import SearchbarSection from './SearchbarSection';
import RightSection from './RightSection';
import AboutSection from './AboutSection';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css';

const CompanyProfile = () => {
  return (
    <div className="container-fluid p-0">
      <div className="row no-gutters">
        <div className="col-lg-2 col-md-3 col-12 leftcol">
          <LeftSection />
        </div>
        <div className="col-lg-8 col-md-9 col-12 middlecol">
          <SearchbarSection />
          <PageBanner />
          <AboutSection />
        </div>
        <div className="col-lg-2 col-12 rightcol">
          <RightSection />
        </div>
      </div>
    </div>
  );
};

export default CompanyProfile;